import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/81_card_back_halloween_moon/81_card_back_halloween_moon"
 * Contains 1 texture(s)
 */
export class CardsBacks81CardBackHalloweenMoonAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/81_card_back_halloween_moon/81_card_back_halloween_moon';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '81_halloween_moon.png'
    ] as const;
}
